export default function ContractTaxRisk({
  isChecked,
  handleCheckboxChange,
  handleNextButtonClick,
}) {
  const contractText = `美國稅務風險自檢課：美籍身份、海外收入與補報入門
購買同意事項（購買契約書）

請於報名並完成付款前詳閱下列條款。當您完成報名並完成付款，即表示本契約成立，並視為您已詳細閱讀、理解並同意遵守以下條款。

一、本課程性質
「美國稅務風險自檢課：美籍身份、海外收入與補報入門」（以下簡稱「本課程」）係由捷進顧問有限公司（Direct Line Consulting Co.，另稱 Becker Taiwan）（以下簡稱「本公司」）所提供之線上隨選專業知識分享與實務訓練課程。
本課程屬專業研習與風險辨識訓練活動，目的在於協助學員理解美國稅務申報義務、海外收入、海外帳戶、投資收入、租金收入、FBAR、FATCA 與補報風險等基礎觀念。
本課程不提供個別法律、稅務、投資或資產規劃建議，亦不取代任何個案專業諮詢。
學員報名本課程，即表示了解並同意本課程之性質為專業知識分享、實務風險辨識與基礎稅務架構訓練活動。

二、本服務內容
本公司依課程規劃提供以下服務：
● 講師預先錄製之線上課程影片
● 美國稅務基本觀念、申報義務與風險辨識教學
● 常見跨境稅務情境與案例說明
● 若有需要，課後將免費媒合美國註冊稅務師進一步接洽
前項課程折抵優惠之實際折抵金額，將依適用課程系列及本公司公告之優惠辦法而定。本公司保留優惠適用資格、折抵金額、適用課程範圍及相關細節之最終解釋權。
本系列美稅課程係依課程錄製當時之最新法規與實務內容製作；除本公司另行公告外，影片及講義不提供後續更新服務。

三、課程形式、觀看平台與使用期限
本課程不提供現場面授或線上直播，而是由講師事先錄製完成之線上隨選課程。
本課程上架於「捷進中文雲端平台」。購買者完成付款後，應以個人帳號登入觀看。
本課程使用期限自購買日起算一年；於使用期限內，購買者得不限次數重複觀看已上架之課程影片。
本契約所稱「購買日」，係指本公司確認購買者完成付款之日。使用期限屆滿後，課程影片與講義之使用權限即終止；除本公司另有書面同意外，不得要求暫停、順延或延長使用期限。
本課程總時數為 3 小時。

四、課程購買與帳號開通
本課程採線上販售。購買者應依本公司指定方式完成購買資料填寫及一次性付款。
未完成付款者，本公司不提供課程影片觀看或講義使用權限。
本公司將依購買者提供之姓名、電子郵件、聯絡電話及其他必要資料，辦理課程帳號建立、權限開通與課程通知。
購買者應自行確認聯絡資訊正確並留意收信狀況。若因購買者提供之資料錯誤、信箱設定、垃圾郵件過濾、未即時查收訊息或其他可歸責於購買者之因素，導致未收到帳號、課程通知或其他資訊，本公司不負延誤通知之責任。

五、課程費用
本課程費用依課程網站及本公司公告價格為準。實際付款金額、付款方式及發票或收據開立方式，依本公司報名頁面、付款通知或客服人員說明為準。
本公司得依行銷活動提供早鳥優惠、團報優惠、企業／團隊優惠或其他促銷價格，優惠條件依活動公告為準。不同優惠不得合併使用，除非本公司另有明確公告。
課程費用須於購買後依指定方式完成一次性付款。未完成付款者，本公司不開通課程觀看及講義使用權限。

六、課程平台服務、異動與暫停
本公司應提供具有可合理期待安全性之線上課程服務。
本公司因線上課程平台相關軟硬體設備進行營運上必要之搬遷、更換、升級、保養或維修，或因系統因素、天災、疫情、政府命令、不可抗力或其他非可歸責於本公司之因素，得暫停本服務之全部或一部。
本公司因前項事由暫停本服務之全部或一部時，原則上應於暫停服務七日前，於網站或平台公告，並以電子郵件、LINE 官方帳號或其他適當方式通知購買者；但因臨時性、急迫性或不可歸責於本公司之事由者，不在此限。
若因可歸責於本公司之事由致本服務無法提供，且依法應退還授權使用費者，本公司將按尚未使用日數占一年授權期間總日數之比例退還。
教學內容或教材如有錯誤，本公司應於知悉之日起三個工作日內（國定假日、例假日及防災假除外）完成更正或修復，並以適當方式公告。

七、退費政策（購買前請詳閱）
購買者因個人因素申請退費，應依下列規定辦理：

1. 購買後七日內
購買者於購買後七日內，且尚未點開任何課程影片者，得以書面方式向本公司申請退費，包括發送電子郵件至 service@beckertw.com，或傳送訊息至 Becker Taiwan LINE 官方帳號。

2. 已使用課程內容
購買者於前項七日期間內，如已點開任何一部課程影片，即視為已開始使用本服務，恕不接受退費申請。

3. 超過購買後七日
購買日後超過七日，無論是否已觀看課程影片，恕不接受退費申請。
本課程購買後不得申請暫停效期、延長效期、變更為其他課程，亦不得將課程使用權限轉讓予他人。

4. 因可歸責於本公司之事由
若因可歸責於本公司之事由致本服務無法提供，且依法應辦理退費者，依本契約第六條辦理。

八、帳號安全與使用權限
購買者領取或建立帳號後，應妥善保管其登入密碼，確保不為他人得知。利用該帳號與密碼登入課程平台者，推定為購買者本人之行為。
課程觀看與使用權限僅限購買者本人使用，不得將個人帳號、密碼或課程使用權限分享、出借、轉讓或提供予第三人使用。
本公司保留針對疑似帳號異常使用行為（包括但不限於多地 IP 登入或多人共用）進行審核、限制或暫時凍結帳號之權利，以防止共享帳號或其他未經授權之使用。
因非可歸責於本公司之事由導致帳號或密碼外洩時，購買者應儘速通知本公司；本公司除提供必要協助外，不負其他法律責任。

九、課程觀看方式與設備需求

1. 課程觀看方式
本課程提供於「捷進中文雲端平台」，供購買者登入個人帳號觀看。行動裝置限使用平台 APP 觀看課程。
購買者應自行確認所使用之裝置、作業系統、瀏覽器、APP、音訊及網路連線可正常運作。

2. 軟硬體設備基本規格及要求
（一）Windows PC／NB：Windows 7 以上
（二）Apple PC／NB：macOS 10 以上
（三）Apple 行動裝置：iOS 13.0 以上
（四）Android 行動裝置：Android 8.0 以上
※ 行動裝置限定使用 APP 版觀看課程。
建議使用下載速度 20 Mbps 以上之寬頻網路。未列示之軟硬體、系統或網路環境，本公司不保證其觀看品質；若因購買者端設備、網路環境或操作問題導致無法順利使用課程，本公司不負補課、延長效期或退費責任。

十、智慧財產權與課程內容使用限制
本課程所有教材、講義、投影片、線上課程影片、課程錄音、案例資料及相關內容之智慧財產權，均屬捷進顧問有限公司、授課講師或合法權利人所有。
學員僅得為個人學習目的使用，不得為任何商業、公開、轉售、散布或再製目的使用。
於課程使用期限內及期限屆滿後，購買者均不得：
● 自行錄音
● 自行錄影
● 拍照
● 側錄螢幕畫面
● 語音轉錄
● 逐字紀錄（scribe）
● 翻印教材
● 複製課程內容
● 轉載或引用未經授權之課程資料
● 上傳至網路、社群平台、雲端空間或任何公開／非公開共享平台
● 散布、販售、交換、出借或提供予第三人使用
如有侵害智慧財產權、違反課程內容使用限制或其他不當使用行為，本公司將依法追究相關民刑事責任，並得停止該學員參與課程或使用課程相關資源之權利，且不予退費。

十一、平台使用規範
購買者使用捷進中文雲端平台時，應遵守本公司相關規範與指示，不得影響平台、課程服務或其他使用者之正常使用。
購買者不得有下列行為：
● 將個人帳號、密碼或課程使用權限提供予他人使用
● 規避、破解或干擾平台之驗證、存取限制或其他技術保護措施
● 蓄意散布足以干擾網站或平台系統正常運作之電腦程式
● 於本公司網站或平台散布恐嚇、毀謗、侵害他人隱私、色情或其他違反法令、公序良俗之文字、圖片或影像
● 冒用他人身份購買、登入或使用本課程
● 其他不法、侵權或違反本契約之行為
若購買者有前項行為，情節重大，或經本公司通知限期改正而屆期未改正者，本公司得停止其帳號或課程使用權限，且不予退費，並得依法追究相關責任。

十二、隱私權聲明
本公司依個人資料保護法蒐集購買者於購買、付款、帳號建立、客服聯繫及課程服務過程中提供之資料，包括但不限於：
● 姓名
● 電子郵件
● 聯絡電話
● LINE 帳號或其他聯絡資訊
● 付款資訊
● 發票或收據開立資訊
● 購買課程與平台使用紀錄
● 客服往來紀錄

使用目的包括：
● 課程購買管理
● 付款與帳務處理
● 身份確認、帳號建立與平台管理
● 課程通知
● 客戶服務
● 課後資源或優惠通知
● 行銷資訊通知
● 法令遵循或爭議處理

本公司將於服務存續期間、業務所需期間或法律規定之保存期限內利用該資料。
如學員需行使個資相關權利，得來信 service@beckertw.com 與本公司聯繫。

十三、免責聲明
本課程內容僅供學習與專業能力提升之用，不構成法律、稅務、投資或其他專業建議。
美國稅務申報與補報涉及個人身份、居住地、收入來源、資產類型、帳戶狀況、申報歷史、婚姻與家庭狀態、持股架構及其他具體事實。學員不得僅依本課程內容自行判斷個案申報義務、補報方式、揭露責任、稅負結果或罰則風險。
如有個別資產規劃、稅務申報、補報、海外資產揭露或風險判斷需求，應洽詢合格律師、會計師、EA、稅務律師或其他專業顧問。
本公司及授課講師不保證學員完成本課程後，即可自行完成美國稅務申報、補報、揭露程序或處理任何個案稅務問題，亦不保證學員因參與本課程而取得特定稅務、法律、財務或商業結果。

十四、購買資格
購買本課程者應為：
● 具有完全行為能力之人；或
● 已取得法定代理人同意之限制行為能力人。
若購買者代表公司、團體或第三人報名，購買者應確認其有權代表該公司、團體或第三人完成報名、付款並同意本契約條款。

十五、管轄法院
因本契約所生之一切爭議，雙方同意以臺灣臺北地方法院為第一審管轄法院，但不得排除消費者保護法或民事訴訟法有關小額訴訟管轄法院之適用。

捷進顧問有限公司
Direct Line Consulting Co.
電話：02-2700-0053
客服信箱：service@beckertw.com
地址：台北市大安區信義路四段 6 號 16 樓之 12
統一編號：80523352`;

  const renderLine = (line, index) => {
    const text = line.trim();

    if (!text) {
      return <div key={index} className="mb-3"></div>;
    }

    // 契約主標題
    if (
      index === 0 ||
      text === "購買同意事項（購買契約書）"
    ) {
      return (
        <div key={index} className="text-center mb-2">
          {text}
        </div>
      );
    }

    // 第一層條款標題
    if (/^[一二三四五六七八九十]+、/.test(text)) {
      return (
        <div key={index}>
          <div className="br mb-5 mt-3"></div>
          <div className="h4">{text}</div>
        </div>
      );
    }

    // 第二層條款標題
    if (
      /^\d+\./.test(text) ||
      /^（[一二三四五六七八九十]+）/.test(text)
    ) {
      return (
        <div key={index} className="h5 mt-4 mb-4">
          {text}
        </div>
      );
    }

    // 項目符號
    if (text.startsWith("●")) {
      return (
        <p
          key={index}
          className="mb-2"
          style={{ paddingLeft: "1.5rem" }}
        >
          {text}
        </p>
      );
    }

    // 備註
    if (text.startsWith("※")) {
      return (
        <p
          key={index}
          className="mb-2"
          style={{
            paddingLeft: "1.5rem",
            fontWeight: "500",
          }}
        >
          {text}
        </p>
      );
    }

    return (
      <p key={index} className="mb-2">
        {text}
      </p>
    );
  };

  return (
    <div className="container mb100 mt100">
      <div className="beckertitlename mb100 mt100">
        美國稅務風險自檢課
      </div>

      <div className="card w-75 p-5 m-auto">
        <h5 className="card-title text-black text-center">
          美國稅務風險自檢課：美籍身份、海外收入與補報入門
        </h5>

        <div className="br mb-5 mt-3"></div>

        <div className="card-body">
          <div className="card-text m-auto">
            {contractText.split("\n").map(renderLine)}
          </div>

          <div className="text-center">
            <label>
              <input
                className="m-2"
                type="checkbox"
                value="read"
                checked={isChecked}
                onChange={handleCheckboxChange}
                required
              />
              <span>我已詳閱並且了解</span>
            </label>

            <div
              className="btn btn-primary m-3"
              onClick={handleNextButtonClick}
            >
              下一步
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}